import * as React from 'react';

import { DialogRoute } from 'bernie-core';
import { Layer } from 'bernie-view';

import { useLocalization } from '@shared-ui/localization-context';

import { InfoModal } from 'components/common/info-modal';

export interface DisclaimerDialogBulletListProps {
  dialogId: string;
  dialogType: string;
  disclaimerText: string[];
  handleClose: () => void;
  layerId: string;
  disclaimerTextId: string;
}

export const DisclaimerDialogBulletList: React.FunctionComponent<DisclaimerDialogBulletListProps> = ({
  dialogId,
  dialogType,
  disclaimerText,
  handleClose,
  layerId,
  disclaimerTextId,
}) => {
  const l10n = useLocalization();

  return (
    <DialogRoute id={dialogId} type={dialogType}>
      <Layer id={layerId} onDismiss={handleClose}>
        <InfoModal closeA11yLabel={l10n.formatText('close')} onClose={handleClose}>
          {disclaimerText && disclaimerText.length > 0 && (
            <ul className="uitk-type-list-300">
              {disclaimerText.map((listItem, index) => (
                <li data-stid={`${disclaimerTextId}-${index}`} key={index}>
                  {listItem}
                </li>
              ))}
            </ul>
          )}
        </InfoModal>
      </Layer>
    </DialogRoute>
  );
};
DisclaimerDialogBulletList.displayName = 'DisclaimerDialogBulletList';
